import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'

import { builtinPlugins, defaultConfig } from '../common'

class ClassicEditor extends ClassicEditorBase {}

ClassicEditor.builtinPlugins = builtinPlugins
ClassicEditor.defaultConfig = defaultConfig

export default ClassicEditor
